<template>
  <div
    class="m-message-column"
    @click="_handleRead"
  >
    <div class="m-msg-top">
      <div
        class="u-msg-tt"
        :title="info.msgTitle"
      >{{ info.msgTitle }}</div>
      <div class="u-msg-time">{{ info.msgCreateTime }}</div>
    </div>
    <div
      class="m-msg-bottom"
      :title="
        info.msgDetail && info.msgDetail.length > 55 ? info.msgDetail : ''
      "
    >
      {{
      info.msgDetail && info.msgDetail.length > 55
      ? `${info.msgDetail.substring(0, 55)}...`
      : info.msgDetail
      }}
    </div>
  </div>
</template>

<script>
import Api from '../../api/api'
export default {
  props: {
    info: {
      default: () => {
        return {}
      },
      type: Object
    }
  },
  methods: {
    _handleRead () {
      Api.common.markedRead(this.info.msgId).then(res => {
        this.$emit('read')
      }).catch(err => {
        this.$message.error(err.msg)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.m-message-column {
  width: 100%;
  max-height: 74px;
  font-size: 12px;
  cursor: pointer;
  .m-msg-top {
    height: 34px;
    line-height: 34px;
    padding: 0 16px;
    box-sizing: border-box;
    .u-msg-tt {
      float: left;
      width: calc(~"100% - 120px");
      color: rgba(0, 0, 0, 0.9);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .u-msg-time {
      float: right;
      color: rgba(0, 0, 0, 0.4);
    }
  }
  .m-msg-bottom {
    box-sizing: border-box;
    padding: 0 16px;
    color: rgba(0, 0, 0, 0.4);
    padding-bottom: 8px;
    overflow: hidden;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }
}
.m-message-column:hover {
  background: rgba(30, 127, 255, 0.08);
}
</style>
